// import { Tween, Easing } from '@tweenjs/tween.js';
import { EVENTS, NOTIFICATIONS } from '../lib/constants';
import { GameConfigs } from '../lib/globals/GameConfigs';
import HELPERS from '../lib/globals/helpers/Helpers';
import AnimateEntrance from './helper/animate';
import { textManager } from '../lib/lang/TextManager';

class NotificatitonController {
	constructor(vc, config) {
		this.t = textManager.getTranslationContext();
		this.vc = vc;
		this.configs = config;
		this.msg = '';
		this.vc.notif_bg.close.handler = this.closeHandler.bind(this);
		this.vc[this.configs.item].notif_title.text = this.t(
			NOTIFICATIONS[GameConfigs.notification.code].title
		);
		this.vc[this.configs.item].notif_desc.text = this.t(
			NOTIFICATIONS[GameConfigs.notification.code].desc
		);
		this.vc[this.configs.item].notif_desc.anchor.set(0.5, 0);
		this.vc[this.configs.item].notif_title.anchor.set(0.5, 0);
		AnimateEntrance(this.vc);
		if (GameConfigs.autospin.isAutoOn) {
			HELPERS.dispatchCustomEvent(EVENTS.AUTO_STARTED, {
				numOfBets: GameConfigs.autospin.numOfBets,
				isAutoOn: false,
				leftBets: 0,
				pause: false
			});
			GameConfigs.autospin.isAutoOn = false;
			GameConfigs.autospin.leftBets = 0;
		}
		HELPERS.disableAllButtons(true);
		HELPERS.dispatchCustomEvent(EVENTS.NOTIFICATION, { notification: true });
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		window.addEventListener(EVENTS.MODAL, this, false);
		this.timeout = setTimeout(() => {
			window.addEventListener(EVENTS.INTERACTION, this, false);
		}, 500);
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.INTERACTION:
				const target = this.vc[this.configs.holder].getBounds();
				if (GameConfigs.modal === 'notification') {
					if (
						HELPERS.handleOutsideClick(
							target,
							evt.x,
							evt.y,
							'notification',
							true
						)
					) {
						window.removeEventListener(EVENTS.INTERACTION, this, false);
						// window.removeEventListener(EVENTS.MODAL, this, false);
						this.closeHandler();
					}
				}

				break;
			case EVENTS.MODAL:
				if (GameConfigs.modal !== 'notification') {
					window.removeEventListener(EVENTS.INTERACTION, this, false);
					// window.removeEventListener(EVENTS.MODAL, this, false);
					this.closeHandler();
				}

				break;
			default:
				break;
		}
	}

	removeEvents() {
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		window.removeEventListener(EVENTS.INTERACTION, this, false);
		window.removeEventListener(EVENTS.MODAL, this, false);
	}

	closeHandler() {
		this.resetError();
		this.removeEvents();
		HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
	}

	resetError() {
		if (GameConfigs.bonusBuy) {
			GameConfigs.bonusBuy = false;
			HELPERS.dispatchCustomEvent(EVENTS.BONUS_BUY, { bonus: false });
		}
		HELPERS.disableAllButtons(false);
		HELPERS.dispatchCustomEvent(EVENTS.NOTIFICATION, { notification: false });
		GameConfigs.notification = {
			code: 0,
			message: '',
			status: ''
		};
	}
}

export default NotificatitonController;
